import { Link, useLocation } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import { useSeo } from '@/hooks/useSeo';

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: '页面不存在 - 404 | 瓜田档案局',
    description: '你访问的页面不存在或链接已更新，可返回首页或前往爆料合集库继续浏览。',
    keywords: '404,页面不存在,瓜田档案局',
    path: location.pathname,
  });

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main className="mx-auto flex max-w-content flex-col items-center px-4 py-28 text-center md:px-6 md:py-36">
        <span className="font-heading text-[6rem] font-black leading-none text-primary-200 md:text-[9rem]">
          404
        </span>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
          这个瓜，好像被人删了
        </h1>
        <p className="mt-3 text-sm text-foreground-500">
          链接：<span className="font-mono text-foreground-700">{location.pathname}</span>
        </p>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
          你找的档案可能已被合并、更新了链接，或者从来没存在过。不妨从下面两个入口重新开始。
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/collections"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-stack-line"></i>
            翻阅爆料合集
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}